import "./ProfileLayout.css";
import ProfileNav from "../../components/profilenav/ProfileNav";

const ProfileLayout = ({ children }) => {
  return (
    <div className="profilelayout">
      <div className="profilelayout-content">
        <div className="profilelayout-nav">
          <ProfileNav />
        </div>

        <div className="profilelayout-main">{children}</div>
      </div>
    </div>
  );
};

export default ProfileLayout;
